import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { combineActions, handleActions } from 'redux-actions';
import { upsertResources, completeWithError, upsertResource, upsertResourceSetupUndo, resetResources } from 'data/qcsSyncResourceReducerHelpers';
import * as investmentHoldingsV2Selectors from 'data/investmentHoldingsV2/investmentHoldingsV2Selectors';
import * as investmentQuotesV2Actions from 'data/investmentQuotesV2/investmentQuotesV2Actions';

import { INVESTMENT_HOLDINGS_V2_REDUCER_KEY as KEY} from './investmentHoldingsV2Types';
import * as actions from './investmentHoldingsV2Actions';

const investmentHoldingsV2Reducer = handleActions({

  [actions.createInvestmentHoldingV2]:
    (state, { payload: holding }) => upsertResource(state, holding),
  [actions.createInvestmentHoldingV2Success]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.deleteInvestmentHoldingV2),

  [actions.updateInvestmentHoldingV2]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.updateInvestmentHoldingV2),
  [actions.updateInvestmentHoldingV2Success]:
    (state, { payload: holding }) => upsertResource(state, holding),

  [actions.deleteInvestmentHoldingV2]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.createInvestmentHoldingV2),
  [actions.deleteInvestmentHoldingV2Success]:
    (state, { payload: holding }) => upsertResource(state, holding),

  [combineActions(
    actions.createInvestmentHoldingV2Failure,
    actions.updateInvestmentHoldingV2Failure,
    actions.deleteInvestmentHoldingV2Failure,
  )]: (state, {payload: error, asyncDispatch}) => {
    asyncDispatch(actions.getInvestmentHoldingsV2());
    return resetResources(state, error);
  },

  [actions.getInvestmentHoldingsV2]:
    (state) => state.merge({ isLoading: true }),
  [actions.getInvestmentHoldingsV2Success]:
    (state, action) => {
      const investmentHoldings = upsertResources(state, action.payload);
      const symbols = investmentHoldingsV2Selectors.getSymbols(undefined, investmentHoldings.resourcesById);
      if (symbols.size) {
        action.asyncDispatch(investmentQuotesV2Actions.getInvestmentQuotesV2(undefined, { axiosConfig: { params: { symbols: symbols.join(',') } } }));
      }
      return investmentHoldings;
    },
  [actions.getInvestmentHoldingsV2Failure]:
    (state, { payload: error }) => completeWithError(state, error),

}, mkQcsSyncResourceStore());

export const INVESTMENT_HOLDINGS_V2_REDUCER_KEY = KEY;
export default investmentHoldingsV2Reducer;
